/*产品展示item*/
import { getCatlogsAction } from '@ivymobi/orbit-core/business/productCenter';
import { filter, isUndefined, union } from 'lodash';
import React, { useContext, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { TenantContext, UserContext } from '../../orbit-context';
import { Loading } from '../../components';
import { Box, Divider, Grid, IconButton, Theme, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import './selectionItem.css';
import { MoreHoriz } from '@mui/icons-material';
const SelectionItem = (props) => {
    
  const {showFilter,filters,ClickItem} = props;
  if(!showFilter || Object.keys(showFilter).length==0)
    return null;
  const keys = Object.keys(filters)
  return (
    <Box style={{width:'100%',background:'white'}}>   
    {keys.map((item=>{
      return <Item item={showFilter[item]} mfilter={filters[item]} ClickItem={ClickItem}></Item>
    }))}
      
       
    </Box>); 
};
const useStyles = makeStyles((theme: Theme) => createStyles({
 
  item:{
    background:'#fbfbfb',
    marginRight:'20px' ,
    padding:'9px',
    margin:'3px'  
  },
  selectItem:{
    background:'#fbf1f1',
    marginRight:'20px' ,
    padding:'9px',
    margin:'3px',
    border:'1px solid #f28f90!important'
  }


}));
const Item = (props) =>{
  const {item,ClickItem,mfilter} = props;
  const classes = useStyles();
  if(isUndefined(item))
    return null;
  
  return (
    <Box style={{padding:'10px'}}>
      <Typography style={{fontSize:'17px'}}>{item.name}</Typography>
      <Grid container style={{paddingTop:'10px'}} >
            {item.values.map((_item) => (
              <Grid item xs={6} sm={6} md={3} key={_item.id}>
                <Box onClick={()=>{
                  ClickItem(item.frIdref,_item)
                }} className={(_item.value===mfilter[0]?.value&&_item.valueName===mfilter[0]?.valueName)?classes.selectItem:classes.item}>{_item.valueName?_item.valueName:_item.value}</Box>
              </Grid>
            ))}

          </Grid>
          <Divider style={{marginTop:'30px'}}></Divider>
    </Box>
  )
}
export default SelectionItem;